// extracted by mini-css-extract-plugin
export default {"cardWrapper":"CraftProCard_cardWrapper__fkjWJ"};